import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
import './css/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import scroll from 'vue-seamless-scroll'
import { checklevel } from '@/api/new'

Vue.use(scroll)

Vue.use(dataV)
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.prototype.getPermision = async function(level) {
  try {
    const prarms = {
      level: level
    }
    const response = await checklevel(prarms);
    if (response.status == 200) {
      return true
    } else {
      this.$confirm('当前用户权限不足，是否要升级/续费您的会员', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(async () => {
        if (this.openpaylog) {
          this.openpaylog()
        } else {
          this.$emit('openpaylog', true)
        }
      })
      .catch(() => {
      })
      return false
    }
  } catch (error) {
    console.error('Error checking level:', error);
    return false;
  }
}

new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App)
}).$mount('#app')
